module.exports = __webpack_public_path__ + "static/media/canada_news.82b6f693.png";